import './DeleteButton.css'
import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

interface IProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [x: string]: any;
}

const DeleteButton = ({ children, ...otherProps }: IProps) => {
  return (
    <Button className='btn-lg btnWidth btn btn-default' {...otherProps}>
      <FontAwesomeIcon icon='trash' />
      {children ? children : <></>}
    </Button>)
}

export default DeleteButton